import React from 'react';
import { Box, Stack, Button, CircularProgress } from '@mui/material';
import { VpnKey as VpnKeyIcon } from '@mui/icons-material';

interface CredentialsFormProps {
  email: string;
  password: string;
  loading: boolean;
  onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onBack: () => void;
}

export function CredentialsForm({
  email,
  password,
  loading,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  onBack,
}: CredentialsFormProps) {
  return (
    <Box component="form" onSubmit={onSubmit} autoComplete="on" sx={{ mt: 2 }}>
      <Stack spacing={2}>
        <input
          type="email"
          name="email"
          autoComplete="email"
          required
          placeholder="Email"
          value={email}
          onChange={onEmailChange}
          style={{ padding: 12, fontSize: 16, borderRadius: 4, border: '1px solid #ccc' }}
          disabled={loading}
        />
        <input
          type="password"
          name="password"
          autoComplete="current-password"
          required
          placeholder="Password"
          value={password}
          onChange={onPasswordChange}
          style={{ padding: 12, fontSize: 16, borderRadius: 4, border: '1px solid #ccc' }}
          disabled={loading}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          disabled={loading}
          sx={{ py: 1.5, fontSize: '1rem', fontWeight: 500 }}
          startIcon={loading ? <CircularProgress size={20} /> : <VpnKeyIcon />}
        >
          {loading ? 'Signing in...' : 'Sign in'}
        </Button>
        <Button
          fullWidth
          variant="text"
          size="large"
          onClick={onBack}
          disabled={loading}
          sx={{ py: 1.5, fontSize: '1rem', fontWeight: 500 }}
        >
          Back
        </Button>
      </Stack>
    </Box>
  );
}
